import * as Common from '@tfo/common'
import { useIntl } from "react-intl"

const { Label } = Common.Elements

type ArchivedCheckpointsProps = {
    checkpoints: { checkpointType: string, category: string }[]
}

const ArchivedCheckpoints = ({checkpoints}: ArchivedCheckpointsProps) => {
    if(!checkpoints?.length) {
        return null
    }

    const intl = useIntl()
    const categories = ["Personalia", "Financial", "Legal", "Resume", "Media"]

    return <div style={{
        display: 'grid',
        gridTemplateColumns: 'auto auto auto auto',
        columnGap: '2em',
        rowGap: '1em',
        margin: '0.5em 1em 0 0'
    }}>
        {
            categories
            .filter(category => checkpoints.some(ch => ch.category === category))
            .map(category => (
                <div key={category}>
                    {
                        <>
                            <Label>{intl.formatMessage({ id: `archived.report.category.label.${category}` })}</Label>
                            <ul style={{ marginLeft: '-1em' }}>
                                {
                                    checkpoints.filter(checkpoint => checkpoint.category === category).map(checkpoint => (
                                        <li key={checkpoint.checkpointType} style={{ color: '#a8a8a8' }}>
                                            <span style={{color: 'black'}}>{intl.formatMessage({ id: `service.checkpoints.${checkpoint.checkpointType}` })}</span>
                                        </li>
                                    ))
                                }
                            </ul>
                        </>
                    }
                </div>
            ))
        }
    </div>
}

export default ArchivedCheckpoints